import { createContext } from "react";

import { TemplateManagementHelper } from "./TemplateManagementHelper.ts";

export const TemplateManagementContext =
  createContext<TemplateManagementHelper>({} as TemplateManagementHelper);
